import React from "react";

import { MarkdownViewer } from "dynamic/components/MarkdownViewer";

import Collapse, { CollapseItem } from "./Collapse";

const markdownCustomRenderer = {
  renderer: {
    link(href, _, text) {
      return `<a class="link" href={${href || ""}}>${text}</a>`;
    },
  },
};

const SeoLeasingInfo = ({ content: { sectionTitle, items } }) => (
  <section className="py-16 lg:py-24 border-b">
    <div className="page-container page-container--tight px-5 mb-4">
      <h2 className="headline--6 uppercase">{sectionTitle}</h2>
    </div>
    <div className="w-full max-w-lg mx-auto pb-1">
      <Collapse defaultActiveKey={[items[0].title]} className="collapse">
        {items.map(({ title, content }) => (
          <CollapseItem key={title} title={title} expanded>

            <MarkdownViewer content={content} customOptions={markdownCustomRenderer} />
          </CollapseItem>
        ))}
      </Collapse>
    </div>
  </section>
);

export default SeoLeasingInfo;
